var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExcesoVelocidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#0000e2;}.cls-3{opacity:0.1;}.cls-4{opacity:0.2;}.cls-5{opacity:0.3;}.cls-6{opacity:0.4;}.cls-7{opacity:0.5;}.cls-8{opacity:0.6;}.cls-9{opacity:0.7;}.cls-10{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-exceso-velocidad") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_25",
    "data-name": 25
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183,121.48a67.61,67.61,0,0,1-7,27.93l-8-3.95a58.75,58.75,0,0,0,6.09-23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.26,121.85a67.57,67.57,0,0,0,7,27.56l8-3.95a58.82,58.82,0,0,1-6.11-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.77,91.72a59,59,0,0,0-6.59,24.38H46.27A68,68,0,0,1,54,87.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.47,69A60,60,0,0,0,64.39,87.19l-7.54-4.73a68.86,68.86,0,0,1,21.07-21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.63,59.63A59.13,59.13,0,0,0,87.12,66.3l-4.63-7.61a67.88,67.88,0,0,1,29.53-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.11,66.3A59.08,59.08,0,0,0,117,59.61l.18-8.9a67.81,67.81,0,0,1,29.18,7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.57,86.76a59.9,59.9,0,0,0-18.21-18L151,61.18a68.89,68.89,0,0,1,21.36,21.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M174.05,116.1a59.13,59.13,0,0,0-6.75-24.68l7.77-4.35a67.91,67.91,0,0,1,7.89,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112.73,126a13.7,13.7,0,1,1,11.88-20.5l28.7,20.34-35.16-1A13.65,13.65,0,0,1,112.73,126Zm0-21.23a7.54,7.54,0,0,0-7.15,5.14,7.53,7.53,0,0,0,10.53,9.1l.7-.35,16.33.45-13.33-9.45-.35-.7a7.46,7.46,0,0,0-4.36-3.81A7.57,7.57,0,0,0,112.73,104.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138.91,162.57H90.34a5.41,5.41,0,0,1-5.41-5.4v-7.33a5.42,5.42,0,0,1,5.41-5.4h48.57a5.41,5.41,0,0,1,5.4,5.4v7.33A5.4,5.4,0,0,1,138.91,162.57Zm-47.8-6.17h47v-5.78h-47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcesoVelocidad);
export default __webpack_public_path__ + "static/media/ic-exceso-velocidad.0571fb7a482e540bb9f64dde14e2c84a.svg";
export { ForwardRef as ReactComponent };